import { HTMLAttributes } from 'react'
import { cn } from '@/common/utilities.ts'

interface AccessProps {
  title?: string
  description?: string
  onCheckedChange: () => void
}

type CardProps = HTMLAttributes<HTMLDivElement> & AccessProps

const RoleControl = ({
  title,
  description,
  onCheckedChange,
  className,
  ...props
}: CardProps) => {
  return (
    <div className={cn('py-2 flex items-center gap-2.5', className)} {...props}>
      <input
        type="radio"
        className="w-4 h-4 mr-2 text-primary hover:ring-primary focus:ring-primary"
        name="radio"
        required
        onChange={() => onCheckedChange()}
      />
      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-1.5 leading-none font-semibold text-sm text-gray-900">
          {title}
        </span>
        {description && (
          <span className="text-sm text-gray-500">{description}</span>
        )}
      </div>
    </div>
  )
}

export default RoleControl
